import type { App } from "@upsquad/server";
import type { EdenCall } from "@/src/common/lib/eden-base-query";
import { baseApi } from "@/src/common/services/base-api";

type GetPublicCommunityResponse = App["~Routes"]["community"]["public"][":slug"]["get"]["response"]["200"];
type GetPublicCommunityMobileAppConfigResponse = App["~Routes"]["community-mobile-app"]["public"][":slug"]["get"]["response"]["200"];

export const communityPublicApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getPublicCommunity: builder.query<GetPublicCommunityResponse, string>({
			query:
				(slug): EdenCall<GetPublicCommunityResponse> =>
				(client) =>
					client.community.public({ slug }).get(),
			providesTags: (_result, _error, slug) => [{ type: "PublicCommunity", id: slug }],
		}),
		getPublicCommunityMobileAppConfig: builder.query<GetPublicCommunityMobileAppConfigResponse, string>({
			query:
				(slug): EdenCall<GetPublicCommunityMobileAppConfigResponse> =>
				(client) =>
					client["community-mobile-app"].public({ slug }).get(),
		}),
	}),
});

export const { useGetPublicCommunityQuery, useGetPublicCommunityMobileAppConfigQuery } = communityPublicApi;
